export function validate_route(router, to) {
    const require_auth = to.matched.some(record => record.meta.requires_auth !== false);
    const requires_otp = to.matched.some(record => record.meta.requires_otp === true);
    if (require_auth && !validate_auth(router)) {
        return false; // If token validation fails, do not continue to route
    }

    if (requires_otp && !validate_otp(router)) {
        return false; // If OTP verification fails, do not continue to route
    }
    return true; // If all checks pass, continue to the route
}

export function validate_auth(router) {
    const TOKEN = sessionStorage.getItem('token');
    if (!TOKEN) {
        sessionStorage.setItem('auth_redirect_reason', 'Session expired. Please log in again.');
        router.push({ name: 'UserLogin' }); // Redirect to login page
        return false; // Token is invalid
    }
    return true; // Token is valid
}
  
export function validate_otp(router) {
    const OTP_VERIFIED = sessionStorage.getItem('otp_verified');
    if (!OTP_VERIFIED) {
        sessionStorage.setItem('auth_redirect_reason', 'OTP verification is required.');
        router.push({ name: 'OneTimePin' }); // Redirect to OTP verification page
        return false; // OTP is not verified
    }
    return true; // OTP is verified
}

export function validate_token(router) {
    const TOKEN = sessionStorage.getItem('token');
    if (!TOKEN) {
        router.push({ name: 'UserLogin' });
        return false; // Token is invalid
    }
    return true; // Token is valid
}
